import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';

const renderDom: HTMLElement | null = document.getElementById('simulator');
ReactDOM.render(
    <React.StrictMode>
        <App lang={renderDom && renderDom.getAttribute('lang')} />
    </React.StrictMode>,
    document.getElementById('simulator')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
